<div class="modal-header">
  <button
    type="button"
    class="btn-close"
    (click)="bsModalRef.hide()"
    aria-label="Close"
  >
    <i class="feather x"></i>
  </button>
  <h4 class="modal-title" id="myModalLabel">Manage Apps</h4>
</div>
<div class="modal-body">
  <h4>Add a new App</h4>
  <p>Provide the information to add a new App.</p>
  <form [formGroup]="addAppForm">
    <div class="row">
      <div class="col-sm-4">
        <div class="form-group">
          <label for="AppNameInput01">App name</label>
          <input
            id="AppNameInput01"
            type="text"
            autofocus
            class="form-control"
            formControlName="name"
            placeholder=""
            [ngClass]="
              formUtil.displayFieldCss(
                addAppForm,
                'name',
                addAppFormSubmitAttempt
              )
            "
          />
          <div
            class="form-invalid-message"
            *ngIf="
              !addAppForm.get('name').valid &&
              addAppForm.get('name').dirty &&
              addAppFormSubmitAttempt
            "
          >
            Name cannot be empty
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="form-group">
          <label for="AppCategory01">App category</label>
          <select
            (change)="categoryChange($event.target.value)"
            id="AppCategory01"
            class="form-control"
            formControlName="category"
          >
            <option value="" selected disabled>Choose a category</option>
            <option value="Accounting">Accounting</option>
            <option value="A/P and A/R">A/P and A/R</option>
            <option value="Document Retrieval">Document Retrieval</option>
            <option value="Receipt Capture">Receipt Capture</option>
            <option value="Payroll">Payroll</option>
            <option value="Expense Management">Expense Management</option>
            <option value="Time Tracking">Time Tracking</option>
            <option value="Mileage Tracking">Mileage Tracking</option>
            <option value="Banking">Banking</option>
            <option value="Other Category">Other Category</option>
          </select>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="form-group">
          <label for="AppLogo01">App logo / icon</label>
          <input
            id="AppLogo01"
            type="file"
            accept=".pdf,.doc,.docx,.pptx,.ppt,.xls,.xlsx,.csv,.txt,.rtf,.html,.zip,.mp3,.wma,.mpg,.flv,.avi,.jpg,.jpeg,.png,.gif,.iif"
            #appInput
            class="form-control"
          />
        </div>
      </div>
      <div
        class="col-sm-12"
        *ngIf="addAppForm.get('category').value == 'Other Category'"
      >
        <div class="form-group">
          <label for="AppCategory02">Category Name</label>
          <input
            id="AppCategory02"
            type="text"
            class="form-control"
            formControlName="category_other"
            placeholder="Category Name"
          />
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <label for="AppURL01">App login URL</label>
          <input
            id="AppURL01"
            type="text"
            class="form-control"
            formControlName="url"
            [ngClass]="
              formUtil.displayFieldCss(
                addAppForm,
                'url',
                addAppFormSubmitAttempt
              )
            "
            placeholder="https://domain.com/login"
          />
          <div
            class="form-invalid-message"
            *ngIf="
              !addAppForm.get('url').valid &&
              addAppForm.get('url').dirty &&
              addAppFormSubmitAttempt
            "
          >
            URL cannot be empty
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <!-- <button class="btn btn-primary pull-left" *ngIf="showAddApp == true"><i class="feather plus"></i> Add App</button> -->
  <button
    type="button"
    class="btn btn-default pull-left"
    (click)="bsModalRef.hide()"
  >
    Cancel
  </button>
  <button type="button" class="btn btn-primary pull-right" (click)="saveApp()">
    Add App
  </button>
  <!-- <button type="button" class="btn btn-default" *ngIf="showAddApp == false" (click)="bsModalRef.hide()">Close</button> -->
</div>
